import React from 'react'
import { ListItemButton, ListItemIcon, ListItemText, Collapse, List, Checkbox } from '@mui/material'
import { maxCharactersToString } from 'src/helper/maxCharactersToString'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import DataObjectIcon from '@mui/icons-material/DataObject'
import { cleanKey } from 'src/helper/MapperHelper'
import { isInCheckedBoxList } from './helper'

export function CustomListItem(props) {
  const {
    propKey,
    propValue,
    expandedKeys,
    setExpandedKeys,
    checkedBox,
    setCheckedBox,
    onClickItem,
    isNumeric,
  } = props

  const handleClick = (key) => {
    const index = expandedKeys.findIndex(elem => elem === key)
    let expandedKeysAux = [...expandedKeys]
    if (index > -1) {
      expandedKeysAux.splice(index, 1)
    } else {
      expandedKeysAux.push(key)
    }
    setExpandedKeys(expandedKeysAux)
  }

  const getKey = (key) => {
    if (isNumeric(key)) {
      return `${propKey}[${key}]`
    }
    return key
  }

  return (
    <>
      <ListItemButton onClick={() => handleClick(propKey)} className='list_item_button'>
        <ListItemIcon>
          <DataObjectIcon />
        </ListItemIcon>
        <ListItemText primary={cleanKey(propKey)} />
        {expandedKeys.includes(propKey) ? <ExpandLess /> : <ExpandMore />}
      </ListItemButton>

      {Object.entries(propValue).map((element) => {
        const [key, value] = element
        const key_clean = cleanKey(key)

        return (
          <Collapse
            in={expandedKeys.includes(propKey)}
            timeout='auto'
            unmountOnExit
            key={key}
          >
            <List component='div' disablePadding sx={{ pl: 10 }}>
              {typeof value !== 'object' || value == null ? (
                <ListItemButton onClick={onClickItem(key, value)} className='list_item_button'>
                  <ListItemIcon>
                    <Checkbox
                      className='list_item_checkbox'
                      edge='start'
                      checked={isInCheckedBoxList(checkedBox, key)}
                      tabIndex={-1}
                      disableRipple
                      disabled={!isNumeric(value)}
                    />
                  </ListItemIcon>
                  <ListItemText primary={`${key_clean} : ${maxCharactersToString(value)}`} />
                </ListItemButton>
              ) : (
                <CustomListItem
                  propKey={getKey(key)}
                  propValue={value}
                  expandedKeys={expandedKeys}
                  setExpandedKeys={setExpandedKeys}
                  checkedBox={checkedBox}
                  setCheckedBox={setCheckedBox}
                  onClickItem={onClickItem}
                  isNumeric={isNumeric}
                />
              )}
            </List>
          </Collapse>
        )
      })}
    </>
  )
}
